const $ = require("jquery/dist/jquery"); // CommonJS import is required to support Rappid

// This shim is aliased to "jquery" in the webpack configuration.
// This is necessary for two reasons:
// 1. Lots of existing df code assumes that "$" is available globally
// 2. Kendo assumes that jQuery is available globally after it does "import 'jquery'".
// Those assumptions are true for jquery 3, but not for jquery 2.
// Kendo UI supports 2 and 3, but docfinity code only supports 2.

window.$ = $;
window.jQuery = $;
module.exports = $; // CommonJS export is required to support Rappid
